import React, { useState, FC, useEffect, useRef } from "react";
import { RouteComponentProps, useLocation, } from "react-router-dom";
import "../../Components/Home/home.scss";
import { NavObjectType, NavObjectWinState, TabNames, lddGlobalSessionInfo, PopupPageId, purfileController } from "../../Components/navigationTypes";
import NavFileContainerRightSide from "../../fileToolbar/fileToolbarSideBar";
import MainIFrame, { navigateNewPage } from "../../Components/Home/compat";
import { useDispatch, } from 'react-redux';
import { setSessionState, setSessionInfo, lddStateObject, setActivityCenter, setActivityCenterAddNew, setActivityCenterDelete, setNavigation } from '../../redux/reducer'
import { fileTabVal } from "../../SideDrawer/sideTypes";
import { activityCenterObject } from "../../fileToolbar/ActivityCenter/activityCenterTypes";
import { useAppSelector } from "../../redux/hooks";
import { formatAMPMString } from "../../fileToolbar/fileToolbarFuncs";
import { closeAll, getCurrentContentWindow } from "../../compatManager";
import { NavigationContext } from "../../Context/NavigationContext";
import { ScreenController, getSubTabName } from "../../screenController";
import { ToastMessaging, displayToastMsg } from "../../Components/toastMessages/toastmessages"
import ReactFrame from "../../Components/reactFrame/reactFrame";
import RenewSessionPopup from "../../Components/RenewSessionPopup";
import HOMECONST from "../../Components/Home/const";
import { ActivityCenterContext } from "../../Context/ActivityCenter";
import MainPage from "../MainPage";
import TopBar from "./TopBar";
import { NavFileContainer } from "./sideDrawer/DRSideDrawer";
import { isPageInDrFile, isPageInDrPasscodeFile } from "./drFuncs";
import Loading from "../../Components/Loading";
import UpdatePasswordModal from "../../Components/UpdatePassword/UpdatePasswordModal";
import MarketingCheck from "../../Components/marketingCheck/marketingCheck";

type SomeComponentProps = RouteComponentProps;

export const RightSideContext = React.createContext(
    {
        rightSideBoolean: false,
        account: ''
    }
);
const FileCheckList: Record<string, boolean> = {
    BGTaskCheck: false,
    OneTimeCheck: false
};

const Home: FC<SomeComponentProps> = ({ history }) => {
    const location = useLocation();
    const paramsJSON = new URLSearchParams(location.search).get("params");
    const [page, setPage] = useState<NavObjectType>(paramsJSON ? { ...JSON.parse(paramsJSON) } : {
        component: "dr",
    });
    const search = window.location.search;
    const SESSION_INFO: lddGlobalSessionInfo = useAppSelector((g) => g.SessionInfo);
    const URLsid = new URLSearchParams(search).get('SessionID');
    const dispatch = useDispatch();
    const SessionRenewInterval = useRef(null);
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const [drawerState, setDrawerState] = useState<fileTabVal>(fileTabVal.CLIENTPORTAL);
    const [leftDrawerSelection, setLeftDrawerSelection] = useState<Record<fileTabVal, NavObjectType>>(structuredClone(HOMECONST.defaultLeftDrawerState));
    type RightDrawerOption = "toggle" | "Activity" | "Notes" | "History" | "KeyDates" | "RenAI";
    const DEFAUL_RIGHTTDRAWER: RightDrawerOption = "KeyDates";
    const [rightDrawer, setRightDrawer] = useState<RightDrawerOption>(DEFAUL_RIGHTTDRAWER);
    const [rightBarVisible, setRightBarVisible] = useState<boolean>(window.innerWidth > 1660);
    const activityCenterObjectArray: activityCenterObject[] = useAppSelector((g: lddStateObject) => g.ActivityCenter);
    const [changeNoteDropdown, setChangeNoteDropdown] = useState<boolean>(false);
    const [showPasswordModal, setShowPasswordModal] = useState(false);

    async function handleGenSessionInfo(resSession, responsePromises): Promise<lddGlobalSessionInfo> {
        const [resUser, resFirm] = await Promise.all(responsePromises.map(r => r.json()));
        const { UserID, StationID, isMSLogin, Username } = resSession.result;
        const UserInfo = resUser.result;
        const Admin = UserInfo.Administrator === "1";
        let { FirstName, Initials, LastName, FullName, SubUserID, UserEmail, UserPhone, UserCellPhone, MSLoginEmail } = UserInfo;
        // COPIED FROM handleGenSessionInfo.tsx (RealtiWeb): For legacy reasons, email and phone are referred to as FirmEmail/FirmPhone if we redo database, can change the names
        UserEmail = UserInfo.FirmEmail;
        UserPhone = UserInfo.FirmPhone;
        if (!(Initials > "")) {
            if (FirstName > "") {
                Initials = FirstName.toUpperCase().substring(0, 1);
            }
            if (LastName > "") {
                Initials += LastName.toUpperCase().substring(0, 1);
            }
        }
        if (!(FullName > "")) {
            if (FirstName > "") {
                FullName = FirstName
            }
            if (LastName > "") {
                FullName += ` ${LastName}`
            }
        }
        const FirmInfo = resFirm.result.firm;
        let { FirmName, FirmPhone, FirmCity, FirmFax, FirmEmail, FirmStreet1, FirmProvince, FirmPostalCode, Lawyers } = FirmInfo;

        const SessionInfo: lddGlobalSessionInfo = {
            appCode: "DR",
            appCountry: "CA",
            appProvince: "Ontario",
            appProvinceShort: "ON",
            sid: URLsid,
            user: {
                isAdmin: Admin,
                account: StationID,
                id: SubUserID,
                firstname: FirstName,
                lastname: LastName,
                fullname: FullName,
                initials: Initials,
                email: UserEmail,
                phone: UserPhone,
                cell: UserCellPhone
            },
            firm: {
                account: Username,
                id: UserID,
                name: FirmName,
                phone: FirmPhone,
                city: FirmCity,
                fax: FirmFax,
                email: FirmEmail,
                address: FirmStreet1,
                province: FirmProvince,
                postalcode: FirmPostalCode,
                Lawyers: Lawyers,
                Staffs: [],
                PaymentReminderDate: FirmInfo.PaymentReminderDate?? null
            },
            MSLoginEmail: (isMSLogin) ? MSLoginEmail : "",
            betaUser: {},
        };

        try {
            // Staff Info
            const staffPromise = await fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${SessionInfo.appProvinceShort}/${UserID}/get/list?SessionID=${URLsid}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    searchType: "all_staff_member",
                    page: 0
                })
            });
            if (staffPromise.status === 200) {
                const resStaff = await staffPromise.json();
                SessionInfo.firm.Staffs = resStaff.result;
            }
        } catch (e) {  }
        return { ...SessionInfo };
    }

    function closeRightDrawer() {
        // Don't close in purfile and too wide
        if (!(window.innerWidth > 1660 && navigationInFile(page))) {
            setRightBarVisible(false);
        }
    }
    function updateWindowDimensions() {
        if (window.innerWidth > 1660) {
            if (navigationInFile(page)) {
                setRightBarVisible(true);
                return;
            }
        }
        closeRightDrawer();
    }
    function lddActivityCentreListener(event) {
        const detail = event?.detail;
        const param = detail?.param
        switch (detail.event) {
            case "add":
                lddActivityCenterAdd(param.msg, param.onclick, param.type, param.lddActivityCenterTracker, param.clearWhenOut);
                break;
            case "delete":
                lddActivityCenterDelete(param.counter);
                break;
            default:
                console.log(`Incorrect Activity Centre event: [${event.detail.event}]`);
                break;
        }
    }
    // async function RenewSession(prov) {
    //     try {
    //         let res = await fetch(`/rplus/${prov}/RenewSessionID.asp?SessionID=${URLsid}`);
    //         let response = await res.text();
    //         if (response.indexOf("<Error>") !== -1) {  // already bad
    //             dispatch(setShowRenewSession(true));
    //         }
    //         else {
    //             dispatch(setShowRenewSession(false));
    //             dispatch(setInternetDown(false));
    //         }
    //     } catch (e) {
    //         dispatch(setInternetDown(true));
    //     }
    // }

    const handleRightDrawerToggle = (option: RightDrawerOption): void => {
        if (option === 'toggle') {
            if (rightBarVisible) {
                closeRightDrawer();
            } else {
                setRightBarVisible(true);
            }
        } else if (rightDrawer === option && rightBarVisible) {
            closeRightDrawer();
        } else {
            setRightDrawer(option);
            setRightBarVisible(true);
        }
    }

    const handleLeftDrawerClick = (newFileTabVal: fileTabVal): void => {
        if (drawerState !== newFileTabVal) {
            setDrawerState(newFileTabVal);
            if (leftDrawerSelection[newFileTabVal] && page.params.formasp === "purfileedit") {
                const navigation = leftDrawerSelection[newFileTabVal];
                navigation.params.id = purfileNavStripPopups(page).params.id;
                if (navigation?.controller?.refresh) {
                    delete navigation.controller.refresh;
                }
                changeFrame(navigation);
            }
        }
    }

    const checkPurfileEdit = (checkNav: NavObjectType) => { return checkNav.component === "main" && checkNav.params?.formasp === "purfileedit" };
    function changeFrame(navObj: NavObjectType): void {
        // Don't update main state if just opening popup window
        if (navObj.popup || navObj.isModal) {
            if (navObj.url) {
                if (typeof navObj.url === "string") {
                    let numberURL = parseInt(navObj.url);
                    if (numberURL === -1 || numberURL === 1) {
                        navObj.url = numberURL;
                    }
                }
                const windowState: NavObjectWinState = {
                    dialogArguments: {
                        liveformPopupDataNode: livedataRootContainer.dataRoot,
                        datalockobj: {},
                    }
                };
                var winState: NavObjectWinState = (navObj.windowState) ? navObj.windowState : windowState;
                let ret = navigateNewPage(navObj, SESSION_INFO.sid, winState);
                if (navObj.callback) {
                    ret.then((val) => {
                        const callbackRet = navObj.callback(val);
                        if (callbackRet && navObj.redirect) {
                            changeFrame(callbackRet)
                        }
                    });
                }
            }
        } else {
            // if (navObj.component === "main" && !navObj.url) {
            //     return;
            // }
            const navPurfileToPurfile = checkPurfileEdit(page) && checkPurfileEdit(navObj);
            const sameIDPurfile = page.params?.id === navObj.params?.id

            // init is for if we refresh page or otherwise go into the page
            if (!navPurfileToPurfile || !sameIDPurfile) {
                navObj = { ...navObj, init: true }
            }
            if (!navPurfileToPurfile) {
                // Close all frame tabs when moving to new component
                if (!closeAll()) {
                    return;
                }
                setChangeNoteDropdown(true);
            }

            // checking navigating from/to File
            if (checkPurfileEdit(page) && !checkPurfileEdit(navObj)) {
                // when get out of a file
                lddActivityCenterClearWhenOut();
                setRightBarVisible(false);
            } else if (checkPurfileEdit(navObj) && !sameIDPurfile) {
                // if entering a new file reset left side to default
                setDrawerState(fileTabVal.CLIENTPORTAL)
                let storageObjGet = window.localStorage;
                let UserDocPreference = storageObjGet.getItem("lddDocumentsDefault");
                let NewDefaultLeftDrawerState = structuredClone(HOMECONST.defaultLeftDrawerState);
                if (UserDocPreference > "") {
                    let newDocController: { label: string, controller: purfileController } = JSON.parse(UserDocPreference);
                    if (newDocController?.controller?.tabName > "") {
                        NewDefaultLeftDrawerState[fileTabVal.CLIENTPORTAL].controller = newDocController.controller;
                        NewDefaultLeftDrawerState[fileTabVal.CLIENTPORTAL].label = newDocController.label;
                    }
                }
                setLeftDrawerSelection(NewDefaultLeftDrawerState);
                // reset FileCheckList
                Object.keys(FileCheckList).forEach(k => FileCheckList[k] = false);
                // reset right sidebar
                setRightDrawer(DEFAUL_RIGHTTDRAWER);
                setRightBarVisible(window.innerWidth > 1660);
            }
            // maintain passcode for DR
            const oldPassCode = page.params?.PassCode;
            if (oldPassCode && !navObj.params?.PassCode && navObj.component !== "dr") {
                navObj.params = {
                    ...navObj.params,
                    PassCode: oldPassCode
                };
            }

            history.push("?SessionID=" + URLsid + "&params=" + encodeURIComponent(JSON.stringify(navObj)));
            // update page
            setPage({ ...navObj });
            dispatch(setNavigation(navObj));
        }
    }

    function GetReactFrame() {
        if (page.reactFrame !== '' && page.reactFrame !== undefined && page.reactFrame !== null) {
            return <ReactFrame reactFrame={page.reactFrame} />
        } else {
            return <></>;
        }
    }

    function lddActivityCenterAdd(
        msg: string,
        onclick: activityCenterObject['browserLink'],
        type: activityCenterObject['type'],
        lddActivityCenterTracker: number | string,  // number for msg from webapp, msg from ReachShell has to use string tracker
        clearWhenOut?: boolean
    ) {
        if (!(rightBarVisible && rightDrawer === "Activity")) {
            displayToastMsg({ id: null, msg: msg, type: type }, onclick)
        }

        let currentDate = new Date();
        let dateStr = currentDate.toDateString().split(" ");
        let timeStr = currentDate.toTimeString();
        timeStr = formatAMPMString(timeStr);

        const newMessage: activityCenterObject = {
            index: lddActivityCenterTracker,
            message: msg,
            browserLink: onclick,
            type: type,
            dateCreated: timeStr + ' ' + dateStr[1] + ' ' + dateStr[2] + ' ',
            clearWhenOut: clearWhenOut ? clearWhenOut : false,
        };

        dispatch(setActivityCenterAddNew(newMessage));
        return lddActivityCenterTracker;
    }

    function lddActivityCenterClearWhenOut() {
        const newActivityCenterObjectArray = activityCenterObjectArray.filter(msg => msg.clearWhenOut === false);
        dispatch(setActivityCenter(newActivityCenterObjectArray));
    }

    function lddActivityCenterDelete(counter: number | string) {
        dispatch(setActivityCenterDelete(counter));
    }

    const checkMustChangePassword = async () => {
        try {
            const response = await fetch(
                `/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/${SESSION_INFO.firm.id}/uv/get/user?SessionID=${SESSION_INFO.sid}&id=${SESSION_INFO.user.id}`
            );

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            if (data.ok && (data.result['MustChange'] === 1 || data.result['MustChange'] === '1')) {
                setShowPasswordModal(true);
            }
        } catch (error) {
            console.error('Error checking mustChange:', error);
        }
    };

    //  - Load SessionInfo (even not async)
    useEffect(() => {
        const url = new URL(window.location.href);
        if (url.searchParams.size == 0) {
            const redirectUrl = process.env.REACT_APP_REDIRECT_URL_ON_DR_403 || "./loginldd.html?ErrorMsg=Invalid Session.";
            window.location.href = redirectUrl;
            return;
        }
        if (url.searchParams.has('SessionID') && url.searchParams.get('SessionID') != "null") {
            // Load SID into state
            if (SESSION_INFO?.sid !== URLsid) {
                dispatch(setSessionState(URLsid));
            }
            // load the rest SESSION_INFO
            fetchData();
            return () => {
                if (SessionRenewInterval.current) {
                    clearInterval(SessionRenewInterval.current)
                }
            }
        }

        async function fetchData() {
            const res = await fetch(`/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/cur/uv/get/curUser?SessionID=${URLsid}`);
            if (res.status === 403) {
                const redirectUrl = process.env.REACT_APP_REDIRECT_URL_ON_DR_403 || "./loginldd.html?ErrorMsg=Session timeout.";
                window.location.href = redirectUrl;
            }
            const resSession = await res.json();
            const { UserID, StationID } = resSession.result;
            const responsesJSON = await Promise.all([
                fetch(`/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/${UserID}/uv/get/user?id=${StationID}&SessionID=${URLsid}`),
                fetch(`/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/${UserID}/uv/get/firm?SessionID=${URLsid}`),
            ]);
            const SessionInfo: lddGlobalSessionInfo = await handleGenSessionInfo(resSession, responsesJSON);
            dispatch(setSessionInfo(SessionInfo));
        }

    }, [])

    useEffect(() => {
        const checkPurfileEdit = (checkNav: NavObjectType) => { return checkNav.component === "main" && checkNav.params?.formasp === "purfileedit" };
        let navReturn = new Promise((resolve) => {
            let passingObjects = {
                'ShellInitFunc': (window) => { resolve(window) }
            }
            // init is for if we refresh page or otherwise go into the page
            if (!page.init && !page.controller?.refresh && checkPurfileEdit(page)) {
                let currentWindow = getCurrentContentWindow();
                if (currentWindow?.window?.location?.href?.indexOf("purfileedit") !== -1) {
                    resolve(currentWindow)
                    return;
                }
            }
            if (page.init) {
                const tabName: TabNames | PopupPageId = page.controller?.tabName;
                let drawerState = fileTabVal.DETAILS;
                switch (tabName) {
                    case "Issues":
                        // drawerState = fileTabVal.WORKSPACE;
                        break;
                    case "Title Insurance":
                    case "Registrations":
                        // drawerState = fileTabVal.WORKSPACE;
                        break;
                    case "Documents":
                        drawerState = fileTabVal.DOCUMENTS;
                        break;
                    case "Client Portal":
                        drawerState = fileTabVal.CLIENTPORTAL
                        break;
                    case "Basic":
                        const tabNum = page.controller?.tabNumber
                        const subTab = getSubTabName(SESSION_INFO?.appCode, tabName, tabNum);
                        switch (subTab) {
                            case "Title":
                            case "Writ":
                                // drawerState = fileTabVal.WORKSPACE
                                break;
                            default:
                                drawerState = fileTabVal.DETAILS;
                        }
                        break;
                    default:
                        drawerState = fileTabVal.CLIENTPORTAL;
                }
                setDrawerState(drawerState);
            }
            navigateNewPage(page, URLsid, passingObjects);
        })
        if (checkPurfileEdit(page)) {
            if (page.controller?.refresh) {
                setDrawerState(fileTabVal.CLIENTPORTAL);
            }
            navReturn?.then((newWindow: any) => {
                console.log("top loaded")
                if (checkPurfileEdit(page) && newWindow) {
                    const controller = new ScreenController(newWindow);
                    let tabName, tabNumber;
                    if (!page.controller) {
                        // If no controller, set basic page
                        tabName = 'Basic';
                        tabNumber = 0;
                    } else {
                        tabName = page.controller.tabName
                        tabNumber = page.controller.tabNumber
                    }
                    try {
                        controller.setTabFromName(tabName, tabNumber);
                        let newSubState = leftDrawerSelection;
                        if (newSubState[drawerState].controller !== page.controller || newSubState[drawerState].label !== page.label) {
                            newSubState[drawerState].controller = page.controller;
                            newSubState[drawerState].label = page.label;
                            setLeftDrawerSelection(newSubState);
                        }
                    } catch (e) {
                        console.log("Cannot currently setTab, ensure file is loaded")
                    }
                    if (page.scrollToId) {
                        const element = newWindow.document.getElementById(page.scrollToId);
                        if (element) {
                            element.scrollIntoView();
                        }
                    }
                }
            })
        }

        window.addEventListener("LDDChangeFrame", changeFrameEvent);
        return () => {
            window.removeEventListener("LDDChangeFrame", changeFrameEvent);
        }
    }, [location, SESSION_INFO?.appCode, URLsid])
    const changeFrameEvent = (event) => changeFrame((event as any).detail);
    useEffect(() => {
        dispatch(setNavigation(page));
        updateWindowDimensions();
        window.addEventListener('resize', updateWindowDimensions);
        return () => { window.removeEventListener('resize', updateWindowDimensions) }
    }, [page])  // needs to re-addEventListener when state changes

    useEffect(() => {
        window.addEventListener("LDDActivityCentre", lddActivityCentreListener);
        return () => {
            window.removeEventListener("LDDActivityCentre", lddActivityCentreListener);
        }
    })

    useEffect(() => {
        if (SESSION_INFO) {
            checkMustChangePassword();
        }
    }, [SESSION_INFO]);

    const iframeProp = <MainIFrame page={page} />

    return (
        <div style={{height:'100vh'}} className={showPasswordModal ? 'blur-background' : ''}>
            <ActivityCenterContext.Provider value={
                {
                    Add: lddActivityCenterAdd,
                    Delete: lddActivityCenterDelete,
                    ClearWhenOut: lddActivityCenterClearWhenOut
                }
            }>
                <NavigationContext.Provider value={changeFrame}>
                    <RenewSessionPopup URLsid={URLsid} info={SESSION_INFO} page={page} />
                    {(SESSION_INFO || isPageInDrPasscodeFile(page)) ?
                        <>
                            <TopBar />

                            <main className="ldd-width main-container" id="main-content">
                                <div className="main-container-inner">
                                    <NavFileContainer
                                        page={page}
                                        drawerState={drawerState}
                                        setDrawerState={handleLeftDrawerClick} />
                                    <MainPage
                                        info={SESSION_INFO}
                                        page={page}
                                        iframeProp={iframeProp}
                                        dataroot={livedataRootContainer.dataRoot}
                                        reactFileComponent={GetReactFrame()} />
                                    <MarketingCheck.MarketingPopup
                                        info={SESSION_INFO}
                                        page={page}
                                        dataRootContainer={livedataRootContainer}/>
                                </div>
                                <RightSideContext.Provider value={{
                                    rightSideBoolean: rightBarVisible,
                                    account: SESSION_INFO?.user?.account,
                                }}>
                                    <NavFileContainerRightSide
                                        page={page}
                                        sidebarshow={rightDrawer}
                                        datarootContainer={livedataRootContainer}
                                        sidebar='right'
                                        toggle={handleRightDrawerToggle}
                                        toggleState={rightBarVisible}
                                        sid={URLsid}
                                        changeNoteDropdown={changeNoteDropdown}
                                        setChangeNoteDropdown={setChangeNoteDropdown}
                                    />
                                </RightSideContext.Provider>
                                <ToastMessaging />
                            </main>
                        </>
                    : <Loading showMsg extraMsg="Loading DocServices" />}
                    <UpdatePasswordModal 
                        show={showPasswordModal} 
                        onHide={() => setShowPasswordModal(false)}
                    />
                </NavigationContext.Provider>
            </ActivityCenterContext.Provider>
        </div>
    );
};
export default Home;


function purfileNavStripPopups(navObj: NavObjectType): NavObjectType {
    if (navObj.component !== "main" && navObj.params?.formasp !== "purfileedit") {
        return navObj;
    }
    let newController = undefined
    if (navObj.controller) {
        newController = {
            tabName: navObj.controller.tabName,
            tabNumber: navObj.controller.tabNumber,
        }
    }
    const newNav = newController ? {
        ...navObj,
        controller: newController,
    } : { ...navObj }
    delete newNav.action
    delete newNav.actionParam
    delete newNav.callback
    delete newNav.redirect
    delete newNav.init;
    return newNav
}

function navigationInFile(navObj: NavObjectType): boolean {
    if (isPageInDrFile(navObj)) return true;
    return (((navObj.params === undefined && navObj.url === undefined) || navObj.params?.formasp === "purfileedit")
        && (navObj.component === "main" || navObj.reactFrame === 'CLIENTPORTAL'));
}
